/**
 * Télécharge la fiche technique de production (PDF) générée côté serveur.
 *
 * Appelle POST /api/production-sheet avec le contenu du panier + (optionnel)
 * les coordonnées client, puis déclenche le téléchargement du blob retourné.
 */
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function downloadProductionSheet({
  items,
  customer = null,
  orderId = null,
  paid = false,
  lang = "fr",
} = {}) {
  if (!items || items.length === 0) {
    throw new Error(
      lang === "fr"
        ? "Aucun produit dans le panier"
        : "No products in cart",
    );
  }
  const payload = {
    items: items.map((it) => ({
      product_slug: it.product_slug,
      product_name: it.product_name,
      configuration: it.configuration || {},
      quantity: it.quantity || 1,
      unit_price_chf: it.unit_price_chf,
    })),
    customer: customer || undefined,
    order_id: orderId || undefined,
    paid,
  };
  const resp = await axios.post(`${API}/production-sheet`, payload, {
    responseType: "blob",
  });
  const blob = new Blob([resp.data], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  // Extraire le filename depuis Content-Disposition si fourni
  const disp = resp.headers["content-disposition"] || "";
  const match = disp.match(/filename="?([^";]+)"?/i);
  a.download = match ? match[1] : `signapharma_fiche_production.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
